// The one "no data" sentence every empty module shows (Ben, 2026-10-15, Q-012; rules.md "When
// there's no data"): "No shot data for Alma Aagaard in 25/26." Only the data word changes between
// modules. One message whatever the reason (a keeper has no shots, one game played, a league with
// no event data): it doesn't try to tell them apart, and it never suggests another player.

import { humanizeSeasonCode } from "./league-table-view.js";

/**
 * `word` = the module's data ("shot", "pass", "match"). `seasonCode` null = no season to name
 * (the player has no data in any season, so there's no season picker either). Pure.
 */
export function noDataMessage(word: string, player: string, seasonCode: string | null): string {
  return seasonCode === null
    ? `No ${word} data for ${player}.`
    : `No ${word} data for ${player} in ${humanizeSeasonCode(seasonCode)}.`;
}
